"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _ClassBlock = _interopRequireDefault(require("./ClassBlock"));
var Services = _interopRequireWildcard(require("../../services"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // External dependencies
// Custom components
// Services
// Utility functions
// Localization
var AssignPlans = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(AssignPlans, _PureComponent);
  function AssignPlans() {
    var _this;
    (0, _classCallCheck2["default"])(this, AssignPlans);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, AssignPlans, [].concat(args)), _this.state = {
      classIDs: _sbUtils.helpers.sortObjByTitle(_this.props.classData),
      assignedPlans: {},
      rejectionReason: '',
      showRejectionDialog: false,
      showPlanAssignmentDialog: false,
      loading: true
    }, _this._assignPlan = function (classID, designID) {
      _this.setState({
        assignedPlans: _objectSpread(_objectSpread({}, _this.state.assignedPlans), {}, (0, _defineProperty2["default"])({}, classID, designID))
      });
    }, _this._toggleRejectionDialog = function () {
      _this.setState({
        showRejectionDialog: !_this.state.showRejectionDialog
      });
    }, _this._togglePlanAssignmentDialog = function () {
      _this.setState({
        showPlanAssignmentDialog: !_this.state.showPlanAssignmentDialog
      });
    }, _this._rejectPricing = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var rejectionReasonError, success;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('checkEmpty', _this.state.rejectionReason);
          case 2:
            rejectionReasonError = _context.sent;
            if (!rejectionReasonError) {
              _context.next = 6;
              break;
            }
            _this.setState({
              rejectionReasonError: _i18n["default"].t(_tokens["default"].labels.quotes.reasonForRejectingPlans)
            });
            return _context.abrupt("return", null);
          case 6:
            _context.next = 8;
            return _this.props.rejectPricing(_this.props.currentAccountMeta.accountID, _this.state.rejectionReason);
          case 8:
            success = _context.sent;
            if (success) {
              _this._toggleRejectionDialog();
            }
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._submit = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this._togglePlanAssignmentDialog();
            _context2.next = 3;
            return _this.props.assignPlans(_this.props.currentAccountMeta.accountID, _this.state.assignedPlans);
          case 3:
            success = _context2.sent;
            if (success) {
              _this.props.setSelectedSection(null);
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._handleChange = function (value) {
      _this.setState({
        rejectionReason: value
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(AssignPlans, [{
    key: "componentDidMount",
    value: // eslint-disable-next-line require-await
    function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;
        var assignedPlans;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              assignedPlans = {}; // eslint-disable-next-line array-callback-return
              this.state.classIDs.map(function (classID) {
                var classDesigns = _this2.props.designs[classID];
                var designIDs = Object.keys(classDesigns);
                assignedPlans[classID] = designIDs[0];
              });
              this.setState({
                assignedPlans: assignedPlans,
                loading: false
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var whitelabel = this.props.whitelabel;
      if (this.state.loading || this.state.assignedPlans === {}) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.isRevision ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.planDesignAssignment),
        subtitle: _i18n["default"].t(_tokens["default"].labels.planDesign.pleaseSelectPlanDesign),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submit),
        btnOnClick: this._togglePlanAssignmentDialog
      }) : /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.planDesignAssignment),
        subtitle: _i18n["default"].t(_tokens["default"].labels.planDesign.pleaseSelectPlanDesignRejectionWording),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submit),
        btnOnClick: this._togglePlanAssignmentDialog,
        btn2: true,
        btnName2: _i18n["default"].t(_tokens["default"].buttons.rejectPricing),
        btnOnClick2: this._toggleRejectionDialog
      }), this.state.classIDs.map(function (classID, i) {
        var data = _this3.props.classData[classID];

        // if it's modular flex then we don't want to show the parent classes, only the flex classes
        if (data.isModular && data.parentClassID === null) {
          return null;
        }
        var title = "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(data.title);
        return /*#__PURE__*/_react["default"].createElement(_ClassBlock["default"], {
          title: title,
          classID: classID,
          classData: _this3.props.classData,
          assignedPlans: _this3.state.assignedPlans,
          designs: _this3.props.designs,
          onSelect: _this3._assignPlan,
          whitelabel: _this3.props.whitelabel,
          key: i
        });
      }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showRejectionDialog,
        close: this._toggleRejectionDialog,
        title: _i18n["default"].t(_tokens["default"].titles.pricingRejection),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._rejectPricing,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons["continue"]),
        customContainerStyle: {
          width: 500
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.clickContinueSalesNotification)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.rejectionReason),
        fullWidth: true,
        multiline: true,
        rows: 8,
        value: this.state.rejectionReason,
        onChange: function onChange(e) {
          return _this3._handleChange(e.target.value);
        },
        variant: "outlined",
        error: Boolean(this.state.rejectionReasonError),
        helperText: this.state.rejectionReasonError
      }), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showPlanAssignmentDialog,
        close: this._togglePlanAssignmentDialog,
        title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._submit,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons["continue"]),
        customContainerStyle: {
          width: 500
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.clickContinuePlanAssignment)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })));
    }
  }]);
  return AssignPlans;
}(_react.PureComponent);
var _default = exports["default"] = AssignPlans;